type NavigatorWithUserAgentData = Navigator & {
    userAgentData?: {
        platform?: string;
    };
};

export const isApplePlatform = () => {
    const userAgent = navigator.userAgent;
    const platform = navigator.platform ?? '';
    const userAgentDataPlatform = (navigator as NavigatorWithUserAgentData).userAgentData?.platform ?? '';
    const isIosWebKit = /iP(hone|ad|od)/i.test(userAgent) && /AppleWebKit/i.test(userAgent);

    return /macOS|iOS/i.test(userAgentDataPlatform) ||
        /Mac|iPhone|iPad|iPod/i.test(userAgent) ||
        /Mac|iPhone|iPad|iPod/i.test(platform) ||
        isIosWebKit ||
        (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};